import { makeActionCreator } from '../../../utilities'
import { NotificationCenterConstants } from './notificationCenter.constants'

export const fetchNotifications = makeActionCreator(NotificationCenterConstants.FETCH_NOTIFICATIONS)
export const setNotifications = makeActionCreator(NotificationCenterConstants.SET_NOTIFICATIONS, 'items')
export const removeNotification = makeActionCreator(NotificationCenterConstants.REMOVE_NOTIFICATION, 'id')
export const setOpenedFlagId = makeActionCreator(NotificationCenterConstants.SET_OPENED_FLAG_ID, 'id')
export const setReadFlagIds = makeActionCreator(NotificationCenterConstants.SET_READ_FLAG_IDS, 'readFlagIds')
export const markNotificationRead = makeActionCreator(NotificationCenterConstants.MARK_NOTIFICATION_READ, 'id')
export const setNotificationsLoading = makeActionCreator(
  NotificationCenterConstants.SET_NOTIFICATIONS_LOADING,
  'isLoading'
)
export const resetNotificationCenterState = makeActionCreator(NotificationCenterConstants.RESET_STATE)
export const startNotificationPolling = makeActionCreator(NotificationCenterConstants.START_NOTIFICATION_POLLING)
export const stopNotificationPolling = makeActionCreator(NotificationCenterConstants.STOP_NOTIFICATION_POLLING)
export const markNotificationsViewed = makeActionCreator(
  NotificationCenterConstants.MARK_NOTIFICATIONS_VIEWED,
  'viewedIds'
)
export const setPolledNotificationIds = makeActionCreator(
  NotificationCenterConstants.SET_POLLED_NOTIFICATION_IDS,
  'ids'
)
export const setViewedNotificationIds = makeActionCreator(
  NotificationCenterConstants.SET_VIEWED_NOTIFICATION_IDS,
  'ids'
)
